import { isNullOrUndefinedOrEmpty } from 'utils/utils';

export class CommonMapper {
    public static mapBigintIntoNumber(value: bigint): number {
        if (isNullOrUndefinedOrEmpty(value)) {
            return null;
        }
        return Number(value);
    }

    public static mapStringIntoNumber(value: string): number {
        if (isNullOrUndefinedOrEmpty(value)) {
            return null;
        }
        return Number(value);
    }

    public static mapBigintIntoString(value: bigint): string {
        if (isNullOrUndefinedOrEmpty(value)) {
            return null;
        }
        return value.toString();
    }

    public static mapNumberIntoBigint(value: number): bigint {
        if (isNullOrUndefinedOrEmpty(value)) {
            return null;
        }
        return BigInt(value);
    }
}
